import {useMemo} from "react";

import {IUseCountSearchFiltersOptions, useCountSearchFilters} from "../../../search/hooks/use_count_search_filters";
import {ISearchFiltersFormValues} from "../../../search/types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {getSearchFiltersByOfferType} from "../../../search/utils/get_search_filters_by_offer_type";

type FormValuesType = Pick<SearchFormValuesType, "type" | "price" | "rooms">;

export const useNotificationsFilters = (formValues: FormValuesType, customOptions: IUseCountSearchFiltersOptions = {}) => {
    const searchFiltersConfig = useMemo(() => getSearchFiltersByOfferType("notification"), [formValues]);
    const {countBySlots, totalCount} = useCountSearchFilters<ISearchFiltersFormValues>(formValues, searchFiltersConfig, {
        afterMountOnly: true,
        ...customOptions
    });

    return {
        searchFiltersConfig,
        countBySlots,
        totalCount
    };
};
import {useMemo} from "react";

import {IUseCountSearchFiltersOptions, useCountSearchFilters} from "../../../search/hooks/use_count_search_filters";
import {ISearchFiltersFormValues} from "../../../search/types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {getSearchFiltersByOfferType} from "../../../search/utils/get_search_filters_by_offer_type";

type FormValuesType = Pick<SearchFormValuesType, "type" | "price" | "rooms">;

export const useNotificationsFilters = (formValues: FormValuesType, customOptions: IUseCountSearchFiltersOptions = {}) => {
    const searchFiltersConfig = useMemo(() => getSearchFiltersByOfferType("notification"), [formValues]);
    const {countBySlots, totalCount} = useCountSearchFilters<ISearchFiltersFormValues>(formValues, searchFiltersConfig, {
        afterMountOnly: true,
        ...customOptions
    });

    return {
        searchFiltersConfig,
        countBySlots,
        totalCount
    };
};
